// AuroraPage — wrap a page in the premium "aurora glass" treatment: a slow,
// brand-tinted gradient wash behind the header and frosted-glass cards.
// This is the one-line way any page adopts the Phase 2 look:
//
//   export default function MyPage() {
//     return (
//       <AuroraPage>
//         <PageHeader title="…" />
//         <Card>…</Card>   {/* .ui-card / .ui-stat / .pn / .sc turn to glass */}
//       </AuroraPage>
//     );
//   }
//
// The gradient's leading color is the tenant brand, motion honors
// prefers-reduced-motion, and everything is theme-aware (see globals.css).

import { HTMLAttributes, ReactNode } from 'react';

export interface AuroraPageProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export default function AuroraPage({ children, className, ...rest }: AuroraPageProps) {
  return (
    <div className={['aurora', className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </div>
  );
}
